var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodbo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18663 2.00135C5.088 2.00135 5 2.08442 5 2.17757V9.79785C5 9.8915 5.088 9.9594 5.18663 9.9594H6.08876V14.0419H5.18663C5.088 14.0419 5 14.1244 5 14.2181V21.8384C5 21.9321 5.088 22 5.18663 22H10.88C10.9786 22 11.0511 21.9322 11.0511 21.8384V14.2181C11.0511 14.1947 11.06 14.1652 11.0511 14.1454V9.85839C11.06 9.83868 11.0511 9.82261 11.0511 9.7992V2.17893C11.0511 2.08577 10.9786 2.00271 10.88 2.00271H5.18663V2.00135ZM13.1201 2.00135C13.0214 2.00135 12.9489 2.08442 12.9489 2.17757V9.79785C12.9489 9.82126 12.94 9.83609 12.9489 9.85704V14.1441C12.94 14.165 12.9489 14.1946 12.9489 14.2167V21.8371C12.9489 21.9307 13.0214 21.9986 13.1201 21.9986H18.8134C18.912 21.9986 19 21.9309 19 21.8371V14.2167C19 14.1231 18.912 14.0405 18.8134 14.0405H17.9113V9.95805H18.8134C18.912 9.95805 19 9.89027 19 9.79649V2.17615C19 2.08299 18.912 2 18.8134 2H13.1201V2.00135Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodbo2);
export default __webpack_public_path__ + "static/media/codbo2.b25f37a7a61b5e09cc5d6d750a44be44.svg";
export { ForwardRef as ReactComponent };